import React, { useState } from "react";
import TextField from "../Partial/TextField";
import Button from "../Partial/Button";
import CloseIcon from "../../assets/Icons/CloseIcon";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { createUserApiCall } from "../../store/actions/projectAction";
import SelectField from "../Partial/SelectField";

const statusOptions = [
  {
    label: "Active",
    value: "Active",
  },
  {
    label: "Inactive",
    value: "Inactive",
  },
];

function CreateUserModal({ onClose, setUserData, userData }) {
  const [buttonLoading, setButtonLoading] = useState();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const dispatch = useDispatch();

  const onSubmit = (data) => {
    dispatch(
      createUserApiCall({
        ...data,
        role: "user",
      })
    ).then((result) => {
      if (result?.payload?.success) {
        setUserData(result?.payload?.user);
        onClose();
      }
    });
  };

  return (
    <div className="w-full h-screen fixed top-0 left-0 bg-gray-600 bg-opacity-50 flex justify-center items-center">
      <div className="bg-[#F3F3F5] p-6 pt-14 rounded-lg shadow-lg w-full sm:w-3/4 md:w-1/2 lg:w-1/3 relative">
        <div
          className="absolute right-4 top-4 cursor-pointer"
          onClick={onClose}
        >
          <CloseIcon />
        </div>
        <form className="flex flex-col gap-2" onSubmit={handleSubmit(onSubmit)}>
          <TextField
            placeholder="Enter Full Name"
            register={register("name", {
              required: "Full Name is required",
            })}
            errorMessage={errors.name?.message}
          />
          <TextField
            placeholder="Enter Email"
            register={register("email", {
              required: "Email is required",
            })}
            errorMessage={errors.email?.message}
          />

          <SelectField
            options={statusOptions}
            placeholder="Select Room"
            register={register("status", {
              required: "Status is required!",
            })}
            errorMessage={errors.status?.message}
          />
          <Button
            text="Create User"
            type="submit"
            className="w-full"
            isLoading={buttonLoading}
          />
        </form>
      </div>
    </div>
  );
}

export default CreateUserModal;
